import { render, staticRenderFns } from "./CarouselBanniere.vue?vue&type=template&id=da50c984"
import script from "./CarouselBanniere.vue?vue&type=script&lang=js"
export * from "./CarouselBanniere.vue?vue&type=script&lang=js"
import style0 from "./CarouselBanniere.vue?vue&type=style&index=0&id=da50c984&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports